import { render } from "./cookieBox.vue?vue&type=template&id=167c2d26"
import script from "./cookieBox.vue?vue&type=script&lang=js"
export * from "./cookieBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__